module.exports = __webpack_public_path__ + "static/img/99-2.7decf54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/99-2.jpg
// module id = GkBW
// module chunks = 0